<template>
  <div>
    <!-- <Header></Header> -->
    <Top title="Help Center" content="Help you understand ANTDIY's functions to better grow your business" img="#FF9F85" imgMobile="/static/imgs/help_m.png" :searchFlag="true" searchPlaceholder="Search for articles..."
      @input="getInput($event)" @searchClick="getSearch()" @keydown.enter.native="getSearch()"></Top>
    <div class="blog_top_box" v-if="showerror">
      <div class="blog_tab_top">
        <div  class="blog_tab_tabs">
          <div class="blog_tab_tabs_search" >
            Search results for: {{ this.searchcontent }}
          </div>
        </div>
      </div>
       <div class="blog_tab_divide_line"></div>
    </div>
    <div v-if="showcontent">
      <div class="blog" v-if="!content&&search===false">
      <Skeleton type='list'></Skeleton>
      </div>
      <div class="blog" v-html="content" v-if="content&&search===false"></div>
      <div class="blog blog2" v-if="search===true">
        <ul>
          <li v-for="(item) in tabledata" :key="item.name">
            <a :href=item.href rel="noreferrer noopener" target="_blank" >{{item.title}}</a>
          </li>
        </ul>
      </div>
    </div>
    <div class="blog" v-else>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import Header from './common/header.vue'
import Footer from './common/footer.vue'
import Top from './common/top.vue'
import Skeleton from './common/skeleton.vue'

export default {
  name: 'Help',
  components: {
    Header,
    Footer,
    Top,
    Skeleton
  },
  data () {
    return {
      content: '',
      searchText: "",
      searchFlag: false,
      showerror:false,
      showcontent:true,
      search:false,
      tabledata:[],
      searchcontent:''
    }
  },
  deactivated () {
     this.$destroy()
  },
  created () {
    this.getData()
  },
  methods: {
    getData() {
      this.$axios.get(`https://gateway.antdiy.vip/website/posts/49`)
        .then((res)=>{
          if (res.data.success && res.data.post) {
            this.content = res.data.post.post_content
            setTimeout(() => {
              let aList = document.getElementsByTagName('a')
              for (let index = 0; index < aList.length; index++) {
                const element = aList[index];
                element.onclick = (e) => {
                  let id = this.getQuery(e.currentTarget.href, 'p')
                  let blogs = []
                  try {
                    blogs = JSON.parse(localStorage.getItem('help')) || []
                  } catch (error) {

                  }
                  if (!blogs.includes(id)) {
                    blogs.push(id)
                    localStorage.setItem('help', JSON.stringify(blogs))
                  }
                }
              }
            }, 300)
          }
        })
    },
    getQuery (url, name) {
      var reg = new RegExp("(^|&)"+ name +"=([^&]*)(&|$)");
      var r = url.substr(url.indexOf("\?")+1).match(reg);
      if (r!=null) return unescape(r[2]); return null;
    },
    getInput (e) {
      this.searchText = e;
    },
    getSearch () {
       this.showerror=true
       this.searchcontent=this.searchText
      if(this.searchText===''){
        this.showcontent=true
        this.search=false
        document.querySelector('.blog_tab_top').style.width = "100%"
        document.querySelector('.blog_tab_divide_line').style.width = "100%"
      }else{
         this.$axios.get(`https://gateway.antdiy.vip/website/posts?term_ids=6&page=1&size=999&name=${this.searchText.trim()}&need_term_name=true`)
        .then((res) => {
          if (res.data.success && res.data.posts.length!==0) {
            res.data.posts.forEach(element => {
              this.tabledata = [];
              let obj={
                href:`/detail?p=${element.id}`,
                title:element.post_title,
                name:element.id
              }
              this.tabledata.push(obj)
            });
            this.search=true
            this.showcontent=true
            document.querySelector('.blog_tab_top').style.width = "11.5rem"
            document.querySelector('.blog_tab_divide_line').style.width = "11.5rem"
          }else{
            this.showcontent=false
            document.querySelector('.blog_tab_top').style.width = "100%"
            document.querySelector('.blog_tab_divide_line').style.width = "100%"
          }
        })
      }
    },
  }
}
</script>

<style>
  .blog{
    width: 1200px;
    margin: 0 auto;
    padding-bottom: 123px;
  }
  .blog h3{
    margin-top: 151px;
    position: relative;
    font-size: 32px;
    font-family: Helvetica-Bold, Helvetica;
    font-weight: bold;
    color: #222536;
    line-height: 40px;
  }
  .blog h3:before{
    content: '';
    width: 24px;
    height: 4px;
    background: #FC5421;
    border-radius: 2px;
    position: absolute;
    top: -27px;
  }
  .blog ul{
    margin-top: 39px;
  }
  .blog ul li{
    font-size: 20px;
    font-family: Helvetica;
    color: #222536;
    line-height: 48px;
  }
  .blog ul li a:hover{
    color: #FC5322;
  }

  @media (max-width: 767px){
    .blog{
      padding: 1.61rem .46rem 1.15rem;
      width: 100%;
    }
    .blog2{
       padding:0 .46rem 1.15rem;
    }
    .blog h3{
      font-size: .42rem;
      font-family: Helvetica-Bold, Helvetica;
      font-weight: bold;
      color: #222536;
      line-height: .58rem;
      margin: 0;
    }
    .blog ul li{
      font-size: .31rem;
      font-family: Helvetica;
      color: #222536;
      line-height: .48rem;
    }
    .blog ul li + li{
      margin-top: .38rem;
    }
    .blog ul + h3{
      margin-top: 1.23rem;
    }
    .blog h3:before{
      top: -.4rem;
    }
    .blog ul{
      margin-top: .38rem;
    }
  }
</style>
<style scoped>
   .blog_top_box {
    overflow: hidden;
  }
  .blog_tab_divide_line {
    width: 1200px;
    margin: 0 auto 0;
    border-bottom: 1px solid rgba(151, 151, 151, 0.3);
  }
  .blog_tab_top {
    width: 1200px;
    margin: 0 auto 0;
    height: 110px;
    position: relative;
  }
  .blog_tab_tabs {
    height: 110px;
    padding: 0 60px;
    display: flex;
    justify-content: space-around;
    align-items: center;
  }
  .blog_tab_tabs_search {
    height: 40px;
    font-size: 24px;
    font-family: Helvetica;
    color: #222536;
    line-height: 40px;
  }
  @media (max-width: 767px){
    .blog_top_box {
      width: 100%;
      overflow: auto;
    }
    .blog_tab_top {
      width: 11.5rem;
      margin: 0 auto 0;
      height: 1.04rem;
      position: relative;
      padding: 0 0.48rem;
    }
    .blog_tab_divide_line {
      width: 11.5rem;
      border-bottom: 0.01rem solid rgba(151, 151, 151, 0.3);
    }
    .blog_top_box::-webkit-scrollbar {
      /* 组件内滚动条不显示 */
      display: none;
    }
    .blog_tab_tabs {
      height: 1.04rem;
      padding: 0;
      display: flex;
      justify-content: space-around;
      align-items: center;
    }
     .blog_tab_tabs_search {
      height: 0.6rem;
      font-size: 0.3rem;
      font-family: Helvetica-blod, Helvetica;
      font-weight: bold;
      color: #222536;
      line-height: 0.6rem;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/help.vue